import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { HeroStatTile } from '@/types/common';
import { Card } from '@/components/ui/card';

interface HeroStatsTilesProps {
  tiles: HeroStatTile[];
  className?: string;
}

const getColor = (color?: 'green' | 'red') => {
  if (color === 'green') return 'text-green-500';
  if (color === 'red') return 'text-red-500';
  return 'text-gray-500';
};

const HeroStatsTiles: React.FC<HeroStatsTilesProps> = ({ tiles, className }) => {
  // If there are 4 tiles, use grid-cols-4 on md+, otherwise grid-cols-3
  const gridCols = tiles.length === 4
    ? 'grid-cols-1 sm:grid-cols-2 md:grid-cols-4'
    : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3';

  return (
    <div className={`grid ${gridCols} gap-4 ${className || ''}`}>
      {tiles.map((tile, idx) => (
        <Card
          key={tile.label + idx}
          variant="default"
          hover
          padding="sm"
          className="flex flex-col justify-between min-h-[110px]"
        >
          <div className="flex items-center gap-1.5 mb-1">
            {tile.icon && <span className="text-sm flex-shrink-0">{tile.icon}</span>}
            <span className="text-xs font-medium text-[var(--text-secondary)] leading-tight">{tile.label}</span>
          </div>
          <div className="flex items-end justify-between gap-2 w-full">
            <span className="text-xl font-bold text-[var(--text)] flex-shrink-0">{tile.value}</span>
            {tile.percentChange !== undefined && (
              <span
                className={`inline-flex items-center text-[10px] font-semibold px-1.5 py-0.5 rounded flex-shrink-0 ${
                  tile.percentChangeColor === 'green'
                    ? 'bg-green-100 text-green-600 dark:bg-green-900 dark:text-green-400'
                    : 'bg-red-100 text-red-600 dark:bg-red-900 dark:text-red-400'
                }`}
              >
                {tile.percentChangeDirection === 'up' ? (
                  <ArrowUpRight size={12} className={getColor(tile.percentChangeColor)} />
                ) : (
                  <ArrowDownRight size={12} className={getColor(tile.percentChangeColor)} />
                )}
                <span className="ml-0.5 whitespace-nowrap">{tile.percentChangeLabel ?? `${tile.percentChange > 0 ? '+' : ''}${tile.percentChange}%`}</span>
              </span>
            )}
          </div>
        </Card>
      ))}
    </div>
  );
};

export default HeroStatsTiles; 